import React, { useRef, useState, useEffect } from "react";
import { DatePicker, Form } from "rsuite";
import styled from "styled-components";

import Checkbox from "hoc/Checkbox";
import Modal from "components/Modal/Modal";
import CustomField from "components/Form/CustomField";
import { useWindowWidth } from "hooks";
import { toStartDayUTCTime } from "utils";


const ModalDeletePrice = ({ show, isSupplier, onClose, onSuccess }) => {
    const formRef = useRef(null);

    const formDefaultValue = {};

    const [withoutDate, setWithoutDate] = useState(true);
    const [disabled, setDisabled] = useState(false);
    const [formState, setFormState] = useState(formDefaultValue);
    const windowWidth = useWindowWidth();

    useEffect(() => {
        if (withoutDate) {
            setDisabled(false);
        } else if (!withoutDate && formState.start_date) {
            setDisabled(false);
        } else if (!withoutDate && !formState.start_date) {
            setDisabled(true);
        }
    }, [withoutDate, formState]);

    const clearStates = () => {
        setWithoutDate(true);
        setDisabled(false);
        setFormState(formDefaultValue);
    };

    return <Modal
        show={show}
        title="Deleting Price"
        extraDisabled={disabled}
        onClose={() => {
            clearStates();
            onClose();
        }}
        onSuccess={() => {
            const data = {
                ...formState,
                update_allocated_numbers: formState.update_allocated_numbers || false
            };

            if (!data.withoutDate) {
                data.start_date = data.start_date
                    ? toStartDayUTCTime(new Date(data.start_date))
                    : null;
            } else {
                delete data.start_date;
            }

            delete data.withoutDate;


            onSuccess(data);
            clearStates();
        }}
        footer
    >
        {!isSupplier ? <StyledForm
            ref={formRef}
            formDefaultValue={{
                ...formDefaultValue
            }}
            onChange={(formValue) => {
                setFormState(formValue);
            }}
        >
            <StyledRow>
                <Checkbox
                    name="withoutDate"
                    defaultChecked={withoutDate}
                    onChange={(checked) => {
                        setWithoutDate(checked);
                    }}
                >
                    From current moment
                </Checkbox>

                <CustomField
                    className="date-field"
                    accepter={DatePicker}
                    placeholder="Enter Date"
                    name="start_date"
                    disabled={withoutDate}
                    ranges={[
                        {
                            label: "Today",
                            value: new Date()
                        },
                        {
                            label: "Tomorrow",
                            value: new Date().setDate(new Date().getDate() + 1)
                        }
                    ]}
                    disabledDate={(date) => {
                        const today = new Date();
                        today.setHours(0, 0, 0, 0);
                        return date < today;
                    }}

                    // mobile
                    oneTap={windowWidth < 480 && !withoutDate}
                    inline={windowWidth < 480 && !withoutDate}
                />
            </StyledRow>
            <StyledRow>
                <Checkbox name="update_allocated_numbers">
                    Apply default rate for all allocated numbers
                </Checkbox>
            </StyledRow>
        </StyledForm> : <>Are you sure?</>}
    </Modal>;
};

export default ModalDeletePrice;

const StyledForm = styled(Form)`
    display: flex;
    flex-direction: column;
`;

const StyledRow = styled.div`
    display: flex;
    flex-direction: row;
    
    .rs-form-group {
        margin-right: 20px;
    }
    .rs-form-control-wrapper > .date-field {
        width: 200px;
    }
`;